var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-width-expand@m"},[_c('div',{staticClass:"bb-options summary"},[_c('p',{staticClass:"label"},[_vm._v("Summary:")]),(_vm.selected_size != null)?_c('SummaryTable'):_vm._e(),_c('NextButtons',{attrs:{"prev_route":"mattress"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }